// eslint-disable-next-line import/prefer-default-export
export const formatCurrencyGbp = value =>
  value.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 0
  })
